export default "__VITE_ASSET__6Tqujy8k__"